const error = (msg: string) => new Error(`[@bounce/analytics] ${msg}`)

export { error }
